import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import { configurationPersonnelService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.service'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import CheckIcon from '@/cellRenderers/common/CheckIcon.vue'

export const columnsDefAutomationPersonnelEntitiesAssociationGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.name'),
            field: 'name',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.middleName'),
            field: 'middleName',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.surname1'),
            field: 'surname1',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.surname2'),
            field: 'surname2',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.job'),
            field: 'job.translatedName',
            filter: false,
            sortable: false,
            flex: 1
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.tc('configuration.grid.user'),
            field: 'user',
            minWidth: 100,
            filter: false,
            sortable: false,
            cellRendererFramework: CheckIcon,
            flex: 1
        }
    ]

export interface ConfigurationAutomationPersonnelEntitiesAssociationGridState extends CrudModelPaginator<ConfigurationPersonnelResponse> {
    service: typeof configurationPersonnelService
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationGridState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.personnel.entities.association',
        columnsDef: columnsDefAutomationPersonnelEntitiesAssociationGrid(),
        datasource: new PaginatorDatasource(configurationPersonnelService),
        service: configurationPersonnelService
    })
